export default "__VITE_ASSET__4ae409fd__"